import React, { useState } from 'react';

const faqs = [
  {
    icon: 'fa-calendar-check',
    question: 'Reservation & Booking',
    answer: 'All bookings are subject to availability. Reservations must be secured with a valid credit card or deposit. You must be at least 18 years old to make a reservation. Upon booking, a confirmation email with details will be sent. Guests are required to present a valid photo identification at the time of check-in. Acceptable forms of identification include a national ID card or an international passport.<br/><br/>Extensions of stay are subject to availability and will be offered at the prevailing rates at the time the extension request is made.'
  },
  {
    icon: 'fa-clock',
    question: 'Check-in & Check-out',
    answer: 'Check-in time: <strong>2:00 PM</strong><br/>Check-out time: <strong>12:00 PM</strong><br/><br/>Early check-in and late check-out are subject to availability and may incur additional charges.'
  },
  {
    icon: 'fa-tag',
    question: 'Room Rates & Taxes',
    answer: 'All rates include VAT and local taxes unless otherwise specified. Rates include breakfast unless stated.<br/><br/>Additional services (mini bar, spa treatments, excursions) are charged separately.'
  },
  {
    icon: 'fa-child',
    question: 'Children & Extra Beds Policy',
    answer: 'Children aged under 6 stay free of charge with existing bedding. Extra beds can be arranged for an additional fee, subject to availability. Please make a request in advance.'
  },
  {
    icon: 'fa-paw',
    question: 'Pets Policy',
    answer: 'Pets are not permitted within guest rooms or suites. Service animals are allowed; please notify us in advance.'
  },
  {
    icon: 'fa-spa',
    question: 'Spa & Wellness Policy',
    answer: 'Our spa welcomes guests aged 16 and above. Advance booking for treatments is highly recommended. Late arrivals may result in a shortened session.<br/><br/>Cancellations made less than 24 hours prior to the scheduled appointment will incur a 50% charge.<br/><br/>Please inform the spa team of any medical conditions, allergies, or pregnancy prior to booking. Certain treatments may not be suitable for individuals with specific health conditions.'
  },
  {
    icon: 'fa-user-shield',
    question: 'Guest Responsibilities',
    answer: "Guests are responsible for any damage caused to the property. Black Rock reserves the right to charge for repair or replacement costs. Guests must respect other guests' comfort and follow resort rules.<br/><br/>Guests are responsible for securing their belongings and should report any suspicious activity to hotel staff immediately."
  },
  {
    icon: 'fa-house-lock',
    question: 'House Rules',
    answer: 'Smoking is not permitted inside any suites or indoor public areas. Outdoor designated smoking areas are available. Excessive noise after <strong>10:00 PM</strong> is prohibited.<br/><br/>Gatherings and parties of any kind are strictly prohibited in guest rooms. The Hotel reserves the right to evict any unauthorized occupants without prior notice.<br/><br/>Reservation is not transferable.'
  },
  {
    icon: 'fa-lock',
    question: 'Privacy Policy',
    answer: 'We collect guest data to process bookings and provide services. Personal data includes name, ID number, contact details, and payment information. Cookies are used to enhance website experience. We do not share your data with third parties except as required by law. Guests may request to view, correct, or delete their data at any time.'
  },
  {
    icon: 'fa-scale-balanced',
    question: 'Governing Law & Dispute Resolution',
    answer: 'These terms are governed by local laws of Mongolia. Any disputes shall be resolved amicably or through the appropriate local courts.'
  },
];

function PolicyItem({ item, index, activeIndex, setActiveIndex }) {
  const open = activeIndex === index;
  return (
    <div className={`pol-item${open ? ' pol-item--open' : ''}`}>
      <button className="pol-item__btn" onClick={function() { setActiveIndex(open ? null : index); }}>
        <span className="pol-item__icon"><i className={`fa-thin ${item.icon}`} /></span>
        <span className="pol-item__question">{item.question}</span>
        <span className="pol-item__chevron">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </span>
      </button>
      <div className="pol-item__body">
        <div className="pol-item__answer" dangerouslySetInnerHTML={{ __html: item.answer }} />
      </div>
    </div>
  );
}

function Policies() {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <>
      {/* Banner */}
      <section className="banner-header bg-img bg-fixed" data-overlay-dark="5" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/banner/20.jpg)` }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="subtitle">Black Rock Luxury Hotel</div>
              <div className="title">Terms & Policies</div>
            </div>
          </div>
        </div>
      </section>

      {/* Policies section */}
      <section className="pol-section">
        <div className="container">

          {/* Header */}
          <div className="pol-header">
            <div className="pol-header__label">Guest Information</div>
            <h2 className="pol-header__title">Policies & Guidelines</h2>
            <div className="pol-header__divider" />
            <p className="pol-header__desc">
              Please review our policies to ensure a comfortable and enjoyable stay. For further questions, our team is always happy to help.
            </p>
          </div>

          {/* Accordion */}
          <div className="pol-list">
            {faqs.map(function(item, i) { return (
              <PolicyItem key={i} item={item} index={i} activeIndex={activeIndex} setActiveIndex={setActiveIndex} />
            ); })}
          </div>

          {/* Contact strip */}
          <div className="pol-contact">
            <div className="pol-contact__icon"><i className="fa-thin fa-envelope" /></div>
            <div className="pol-contact__text">
              For any questions regarding our policies, please contact us at&nbsp;
              <a href="mailto:info.blackrock@rrc.mn">info.blackrock@rrc.mn</a>
              &nbsp;or&nbsp;
              <a href="tel:+97675100111">+976 75100111</a>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}

export default Policies;
